import './model.scss';
import React from 'react';
import Model from '../../../commonViews/model/model';

interface ModelViewProps {
    onBack: () => void;
    onClose: () => void;
    onConfirm: () => void;
    btnInfo: string;
    isConfirming?: boolean;
    contentItem: React.ReactNode;
    modelTitle: {
        title: string;
        desc: string;
    };
}

const ModelView = React.memo(({ onBack, onClose, onConfirm, btnInfo, isConfirming = false, contentItem, modelTitle }: ModelViewProps) => {
    const content = () => {
        return (
            <div className="myInfoFrom-content">
                {contentItem}
                <div className="all-btn">
                    <div
                        className={`btn ${isConfirming ? 'disabled' : ''}`}
                        aria-disabled={isConfirming}
                        onClick={() => {
                            if (!isConfirming) {
                                onConfirm();
                            }
                        }}
                    >
                        {isConfirming ? 'Checking...' : btnInfo}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="paymentInstructionMask-main">
            <Model
                width="672px"
                height="469px"
                isScroll={true}
                isPhone={false}
                isMobileType={false}
                isShowBack={false}
                isShowClose={true}
                title={modelTitle.title}
                desc={modelTitle.desc}
                content={content()}
                onBackEvent={onBack}
                onCloseEvent={onClose}
            />
        </div>
    );
});

export default ModelView;
